var React = require('react');

function StreamlineFilled27Add1 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23 11H13V1.001C13 .448 12.574 0 12.021 0c-.553 0-1 .447-1 .999L11.012 11H1c-.553 0-1 .447-1 1 0 .552.447 1 1 1h10.01L11 22.999c-.001.552.446 1 .998 1.001h.001c.552 0 1-.447 1.001-.999V13h10c.552 0 1-.448 1-1 0-.553-.448-1-1-1z","key":0}),React.createElement("g",{"key":1},React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z"}))]);
}

StreamlineFilled27Add1.displayName = "StreamlineFilled27Add1";

StreamlineFilled27Add1.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = StreamlineFilled27Add1;

StreamlineFilled27Add1.default = StreamlineFilled27Add1;



//////////////////
// WEBPACK FOOTER
// ./src/shared/static/icons/streamline-filled-27-add-1.svg
// module id = 763
// module chunks = 0